import { createSelector } from 'reselect';
import { createFeatureSelector } from 'features/create-feature-selector';

const featureRootSelector = createFeatureSelector('linkedPages');

export const getLinkedPages = createSelector(
  featureRootSelector,
  (state) => state || { data: null, loading: false, error: null },
);
export const getLinkedPagesData = createSelector(getLinkedPages, (state) => state.data);
export const getLinkedPagesLoading = createSelector(getLinkedPages, (state) => state.loading);
export const getLinkedPagesError = createSelector(getLinkedPages, (state) => state.error);
export const isLinkedPagesFetched = createSelector(getLinkedPagesData, (data) => data !== null);

export const getLinkedPagesBrand = createSelector(getLinkedPagesData, (data) => data?.brand);
export const getLinkedPagesList = createSelector(getLinkedPagesData, (data) => data?.pages);

export const getLinkedPagesLevel5 = createSelector(getLinkedPagesList, (pages) =>
  pages?.filter((page) => page.level === 5),
);
